// Prefix of every class, id and attribute the embed widget puts on a host page. A leaf module with no
// imports, so the SDK's parser-blocking loader can use it without pulling in heavier constants.
export const EMBED_WIDGET_ELEMENT_PREFIX = 'rapidflare';
